// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3lOEF","info":"Note_info__VLIgn","note":"Note_note__1l-bW","actions":"Note_actions__20beA"};